module.exports = __webpack_public_path__ + "media/images/category/food-a71dd9f13033539ac7ebc53d63c7ca82.jpg";